import {
  type TNodeAction,
  type TRange,
  type TNodeVariable,
  type TNodeBooleanVariable,
  type TNodeIntegerRangeVariable,
} from './node.type'
import { EVariableType } from 'src/types/variable'

/**
 * Update action for a boolean condition (yes/no)
 */
export function updateBooleanCondition(
  variable: TNodeVariable,
  conditionKey: 'yes' | 'no',
  action: Partial<TNodeAction>,
): TNodeVariable {
  if (variable.type !== EVariableType.BOOLEAN) {
    return variable
  }

  const updatedCondition = {
    ...variable.condition,
    [conditionKey]: {
      ...variable.condition?.[conditionKey],
      ...action,
    },
  }

  return {
    ...variable,
    condition: updatedCondition,
  } as TNodeBooleanVariable
}

/**
 * Update action for a specific integer range
 */
export function updateIntegerRangeAction(
  variable: TNodeVariable,
  rangeIndex: number,
  action: Partial<TNodeAction>,
): TNodeVariable {
  if (variable.type !== EVariableType.INTEGER_VALUE_RANGE) {
    return variable
  }

  const currentRanges = variable.condition?.ranges || []
  const updatedRanges = currentRanges.map((range, index) =>
    index === rangeIndex
      ? {
          ...range,
          action: {
            ...range.action,
            ...action,
          },
        }
      : range,
  )

  return {
    ...variable,
    condition: {
      ranges: updatedRanges,
    },
  } as TNodeIntegerRangeVariable
}

/**
 * Update all ranges for an integer range condition
 */
export function updateIntegerRanges(variable: TNodeVariable, ranges: TRange[]): TNodeVariable {
  if (variable.type !== EVariableType.INTEGER_VALUE_RANGE) {
    return variable
  }

  return {
    ...variable,
    condition: {
      ranges,
    },
  } as TNodeIntegerRangeVariable
}
